"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSlug = toSlug;

var _speakingurl = _interopRequireDefault(require("speakingurl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toSlug(str, separator = "~") {
  return (0, _speakingurl.default)(str, {
    separator,
    custom: {
      _: separator
    }
  });
}